<script setup lang="ts">
import { RouterLink } from 'vue-router'

defineProps<{
  path?: string
  wrapperClasses?: string
  iconWrapperClasses?: string
  iconClasses?: string
  textWrapperClasses?: string
}>()
</script>

<template>
  <component :is="path ? RouterLink : 'div'" :to="path" :class="['flex flex-row items-center', wrapperClasses]">
    <div
      :class="['bg-accent flex aspect-square items-center justify-center rounded-lg text-white', iconWrapperClasses]"
    >
      <img :class="iconClasses" src="@/assets/icons/logo-sign-light.svg" alt="Anzolo Medical" />
    </div>

    <div :class="['grid text-left leading-tight', textWrapperClasses]">
      <span class="truncate font-semibold">Anzolo</span>
      <span class="truncate text-xs">Electronic Health Records</span>
    </div>
  </component>
</template>
